import { useContext } from 'react';
import { PlaybackContext, PlaybackContextValue } from './playback-context';

export const usePlayback = (): PlaybackContextValue => {
  const ctx = useContext(PlaybackContext);
  if (!ctx) throw new Error('usePlayback must be used inside <PlaybackProvider>');
  return ctx;
};
